<div class="flex justify-start items-start gap-5">
  <button mat-icon-button (click)="navigateBack()">
    <mat-icon class="transform scale-125">arrow_back</mat-icon>
  </button>

  <h1 class="main-page-title min-w-0 mt-[5px]">
    <ng-content></ng-content>
  </h1>
</div>
